import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { Switch } from "antd";
import { useUIPreferences } from "shared/context/UIPreferencesContext";

// Переключаем через UIPreferencesContext, а не applyTheme напрямую —
// иначе antd ConfigProvider (algorithm) не узнаёт о смене темы.
export default function ThemeToggle() {
    const { effectiveTheme, update } = useUIPreferences();
    const isDark = effectiveTheme === "dark";

    const handleChange = (checked) => update({ theme: checked ? "dark" : "light" });

    return (
        <Switch
            checked={isDark}
            onChange={handleChange}
            checkedChildren={<MoonOutlined />}
            unCheckedChildren={<SunOutlined />}
            aria-label="Toggle theme"
        />
    );
}
